"use client";

import { useWebInfoStore } from "context/webInfoStore";
import { languageBuild } from "lib/language";
import styles from "styles/components/topbar.module.css";

const Topbar = () => {
  const webInfo = useWebInfoStore((state) => state.webInfo);
  const lang = "mn";
  const topbarTitle = languageBuild(webInfo, "topbarTitle", lang) || "";

  if (!topbarTitle) return null;

  return (
    <div className={styles.topbar}>
      <div className="container">
        <p className={styles.text}>{topbarTitle}</p>
      </div>
    </div>
  );
};

export default Topbar;
